module.exports = __webpack_public_path__ + "img/hi-life.9ab85523.jpg";